import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { RouteComponentProps, useRouteMatch } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { ISubcode } from '../../../../models/codes.model'
import { doGetSubcode, doUpdateSubcode } from '../../../../store/code.slice';
import { doGetCommonCodes } from '../../../../store/commonCode.slice';
import { doRemoveAuth } from '../../../../store/auth.slice';
import { RootState } from '../../../../store/rootReducer';
import { useSnackbar } from 'notistack';

import Loader from '../../../../components/Loader';
import SimpleHeader from '../../../../components/layout/SimpleHeader';
import Footer from '../../../../components/layout/Footer';
import Editor from '../../../../components/system/code/Editor';
import { errorVariant, successVariant, warningVariant } from '../../../../lib/barVariant';

interface IMatch {
  topId: string;
  subId: string;
}

const SystemCodeSubcodeEdit: FC<RouteComponentProps> = ({
  history,
  location,
}) => {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const { subcode, isLoading } = useSelector((state: RootState) => state.code);
  const { isLoading: commonCodeLoading } = useSelector((state: RootState) => state.commonCode);

  const match = useRouteMatch<IMatch>();
  const topId = match.params.topId;
  const subId = match.params.subId;

  useEffect(() => {
    getCode(topId, subId);
  }, [])

  const getCode = async (topId: string, subId: string) => {
    const res = await dispatch(doGetSubcode(topId, subId));

    switch (res?.status) {
      case 200:
        break;
      case 401:
        dispatch(doRemoveAuth());
        break;
      case 403:
        enqueueSnackbar(t('common.message.forbidden'), warningVariant);
        history.push('/');
        break;
      default:
        enqueueSnackbar(res?.data?.data || t('common.message.error'), errorVariant);
    }
  }

  const onSubmit = async (req: ISubcode) => {
    const res = await dispatch(doUpdateSubcode(topId, subId, req));
    
    switch (res?.status) {
      case 200:
        dispatch(doGetCommonCodes());
        enqueueSnackbar(t('common.message.edit'), successVariant);
        history.push(`/system/code/${topId}/subcode${location.search}`);
        break;
      case 401:
        dispatch(doRemoveAuth());
        break;
      case 403:
        enqueueSnackbar(t('common.message.forbidden'), warningVariant);
        history.push('/');
        break;
      default:
        enqueueSnackbar(res?.data?.data || t('common.message.error'), errorVariant);
    }
  }

  return (
    <div className="content scrollbar">
      {isLoading || commonCodeLoading ? <Loader /> : null}
      <SimpleHeader
        parentMenu={t('common.menu.system')}
        currentMenu={t('system.code.title5')}
      />
      <Editor
        code={subcode || null}
        onSubmit={onSubmit}
        cancelPath={`/system/code/${topId}/subcode${location.search}`}
      />
      <Footer />
    </div>
  )
}

export default SystemCodeSubcodeEdit;
